import { ButtonProps, Button, colors } from 'plume-ui'
import React from 'react'
import { css, keyframes } from '@emotion/react'

type Props = {
  isLoading?: boolean
  spinnerColor?: string
} & ButtonProps

export const LoadableButton: React.FC<Props> = ({
  isLoading = false,
  spinnerColor = colors.border,
  ...props
}) => {
  return (
    <Button
      css={
        isLoading &&
        css`
          color: transparent !important;
          position: relative;
          pointer-events: none;
          &::after {
            animation: ${spinAround} 500ms infinite linear;
            border: 2px solid ${spinnerColor};
            border-radius: 50%;
            border-right-color: transparent;
            border-top-color: transparent;
            content: '';
            display: block;
            height: 1em;
            position: absolute;
            width: 1em;
            position: absolute;
            left: calc(50% - (1em / 2));
            top: calc(50% - (1em / 2));
            position: absolute !important;
          }
        `
      }
      {...props}
    />
  )
}

const spinAround = keyframes`
  @keyframes spinAround
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
`
